'use client';

import React, { useState } from 'react';
import AppImage from '@/components/ui/AppImage';
import Icon from '@/components/ui/AppIcon';

const testimonials = [
{
  id: 'testimonial-001',
  name: 'Maria Santos',
  location: 'Manila, Philippines',
  role: 'Elite Member — 2.5 years',
  quote: 'Richésse gave me something I never expected — a genuine business that fits around my life as a mother. My store has become my identity, and the products genuinely changed how I feel every day.',
  rating: 5,
  avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1e3a1efe8-1772875264718.png",
  avatarAlt: 'Smiling woman with dark hair in professional attire',
  stats: { label: 'Monthly Store Sales', value: '$4,200' }
},
{
  id: 'testimonial-002',
  name: 'Daniel Cruz',
  location: 'São Paulo, Brazil',
  role: 'Diamond Member — 4 years',
  quote: 'I was skeptical about direct selling, but Richésse is different. The products are premium — I use them myself. The education platform helped me develop skills I use every day. My team is 340 people across three countries.',
  rating: 5,
  avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1bf254c2d-1768540209934.png",
  avatarAlt: 'Confident man in casual business attire smiling outdoors',
  stats: { label: 'Team Members', value: '340+' }
},
{
  id: 'testimonial-003',
  name: 'Sophia Reyes',
  location: 'Mexico City, Mexico',
  role: 'Gold Member — 18 months',
  quote: 'The replicated store feature is incredible. I shared my Richésse link on Instagram and had my first customer within two days. The brand does the heavy lifting — I just share my genuine experience.',
  rating: 5,
  avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1f0381e86-1763300454222.png",
  avatarAlt: 'Young professional woman with warm smile in natural lighting',
  stats: { label: 'Customers Served', value: '127' }
},
{
  id: 'testimonial-004',
  name: 'Andrea Garcia',
  location: 'Barcelona, Spain',
  role: 'Silver Member — 8 months',
  quote: 'I started Richésse to get products at member pricing. Eight months later, I have 23 active customers, a small team, and I am covering my rent from my store income. I never imagined this when I first joined.',
  rating: 5,
  avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_191c1ddbc-1772894643557.png",
  avatarAlt: 'Woman with short hair looking confidently at camera in bright setting',
  stats: { label: 'Active Customers', value: '23' }
}];


export default function TestimonialsSection() {
  const [active, setActive] = useState(0);

  return (
    <section className="py-24 lg:py-32 bg-secondary">
      <div className="max-w-screen-2xl mx-auto px-6 lg:px-10">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="flex items-center justify-center gap-3 mb-5">
            <span className="section-divider" />
            <span className="text-xs font-semibold tracking-widest uppercase text-primary">Member Stories</span>
            <span className="section-divider" />
          </div>
          <h2 className="font-display text-section-title text-foreground">
            Real People. Real Results.
          </h2>
        </div>

        {/* Featured testimonial */}
        <div className="card-elevated rounded-2xl overflow-hidden mb-8">
          <div className="grid lg:grid-cols-5">
            {/* Avatar side */}
            <div className="lg:col-span-2 relative min-h-[280px] lg:min-h-auto">
              <AppImage
                src={testimonials?.[active]?.avatar}
                alt={testimonials?.[active]?.avatarAlt}
                fill
                className="object-cover"
                sizes="(max-width: 1024px) 100vw, 40vw" />

              <div className="absolute inset-0 bg-gradient-to-t lg:bg-gradient-to-r from-accent/60 to-transparent" />
              <div className="absolute bottom-6 left-6">
                <p className="text-white font-semibold text-lg">{testimonials?.[active]?.name}</p>
                <p className="text-white/70 text-sm">{testimonials?.[active]?.location}</p>
                <p className="text-primary text-xs font-medium mt-1">{testimonials?.[active]?.role}</p>
              </div>
            </div>

            {/* Content */}
            <div className="lg:col-span-3 p-8 lg:p-12 flex flex-col justify-center">
              <div className="flex gap-1 mb-5">
                {Array.from({ length: testimonials?.[active]?.rating })?.map((_, i) =>
                <Icon key={`star-${active}-${i}`} name="StarIcon" size={18} className="text-primary" variant="solid" />
                )}
              </div>
              <blockquote className="font-display text-xl lg:text-2xl text-foreground leading-relaxed mb-8">
                "{testimonials?.[active]?.quote}"
              </blockquote>
              <div className="flex items-center gap-4 pt-6 border-t border-border">
                <div>
                  <p className="text-2xl font-bold text-foreground tabular-nums">{testimonials?.[active]?.stats?.value}</p>
                  <p className="text-xs text-muted-foreground font-medium">{testimonials?.[active]?.stats?.label}</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Thumbnails */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {testimonials?.map((t, i) =>
          <button
            key={t?.id}
            onClick={() => setActive(i)}
            className={`card-elevated p-4 text-left transition-all duration-200 ${
            i === active ? 'border-primary/50 shadow-gold' : 'hover:border-primary/20'}`
            }>

              <div className="flex items-center gap-3 mb-2">
                <div className="w-9 h-9 rounded-full overflow-hidden flex-shrink-0 relative">
                  <AppImage src={t?.avatar} alt={t?.avatarAlt} fill className="object-cover" sizes="36px" />
                </div>
                <div>
                  <p className="text-xs font-semibold text-foreground">{t?.name}</p>
                  <p className="text-[10px] text-muted-foreground">{t?.location}</p>
                </div>
              </div>
              <p className="text-xs text-muted-foreground line-clamp-2">{t?.quote}</p>
            </button>
          )}
        </div>
      </div>
    </section>);

}